import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IListState, PaginationType } from '@typings/requestPayloads'

export interface IWishListsQueryPaginationPayload {
    query?: any
    pagination?: PaginationType
    sagaCB?: {
        onSuccess: any
    }
}

const initialState: IListState = {
    status: STATUS.IDLE,
    data: [],
    pagination: {
        skip: 0,
        hasTotal: true,
        total: 0,
        limit: 10
    },
    errors: null
}

const wishListsListSlice = createSlice({
    name: 'wish-lists/list',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IWishListsQueryPaginationPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload.data
            state.pagination = {
                ...state.pagination,
                skip: action.payload.skip,
                total: action.payload.total
            }
        },
        onAddToList(state, action) {
            state.data = [...state.data, action.payload]
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const wishListsListActions = wishListsListSlice.actions
export default wishListsListSlice.reducer
